
import { ArrowDown, ArrowUp } from "lucide-react";
import { Membership } from "../../utils/types";
import { formatDate } from "../../utils/formatters";
import { SortMembersConfig } from "../hooks/useSortMembers";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface MembersTableProps {
  members: Membership[];
  sortConfig: SortMembersConfig | null;
  onSort: (key: keyof Membership) => void;
}

export const MembersTable = ({ members, sortConfig, onSort }: MembersTableProps) => {
  // Fonction pour afficher l'icône de tri
  const getSortIcon = (columnKey: keyof Membership) => {
    if (sortConfig && sortConfig.key === columnKey) {
      return sortConfig.direction === 'asc' ? <ArrowUp size={14} /> : <ArrowDown size={14} />;
    }
    return null;
  };

  return (
    <Table>
      <TableCaption>Liste des membres</TableCaption>
      <TableHeader className="bg-primary text-white">
        <TableRow>
          <TableHead 
            onClick={() => onSort('first_name')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Prénom {getSortIcon('first_name')}
          </TableHead>
          <TableHead 
            onClick={() => onSort('last_name')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Nom {getSortIcon('last_name')}
          </TableHead>
          <TableHead 
            onClick={() => onSort('email')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Email {getSortIcon('email')}
          </TableHead>
          <TableHead 
            onClick={() => onSort('amount')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Montant {getSortIcon('amount')}
          </TableHead>
          <TableHead 
            onClick={() => onSort('additional_donation')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Don additionnel {getSortIcon('additional_donation')}
          </TableHead>
          <TableHead 
            onClick={() => onSort('membership_type')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Type d'adhésion {getSortIcon('membership_type')}
          </TableHead>
          <TableHead 
            onClick={() => onSort('payment_status')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Statut du paiement {getSortIcon('payment_status')}
          </TableHead>
          <TableHead 
            onClick={() => onSort('created_at')} 
            className="cursor-pointer hover:bg-primary/80 transition-colors"
          >
            Date d'adhésion {getSortIcon('created_at')}
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {members.map((member) => (
          <TableRow key={member.id}>
            <TableCell>{member.first_name}</TableCell>
            <TableCell>{member.last_name}</TableCell>
            <TableCell>{member.email}</TableCell>
            <TableCell>{member.amount}€</TableCell>
            <TableCell>{member.additional_donation ? `${member.additional_donation}€` : '-'}</TableCell>
            <TableCell>{member.membership_type}</TableCell>
            <TableCell>{member.payment_status}</TableCell>
            <TableCell>{formatDate(member.created_at)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
